export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14923.47bc59ed.jpg";